import { render } from "./CampaignStateLabel.vue?vue&type=template&id=072d5ba9&ts=true"
import script from "./CampaignStateLabel.vue?vue&type=script&lang=ts"
export * from "./CampaignStateLabel.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./CampaignStateLabel.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__